export const MAPS_URL = (query) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

export const WEDDING = {
  bride: "Morgane",
  groom: "Bruno",
  dateISO: "2027-05-15T16:30:00+02:00",
  dateShort: "15 · 05 · 2027",
  dateLong: "Samedi 15 mai 2027",
  deadline: "28 février 2027",
  city: "Sainte-Foy, Vendée",
  domaine: {
    name: "Domaine de l'Établière",
    address: "Route de l'Établière, 85150 Sainte-Foy",
    time: "16h30",
    note: "Accueil dès 16h30, vin d'honneur à 17h00, dîner et soirée sur place.",
  },
  program: [
    {
      time: "16h30",
      title: "Accueil des Invités",
      desc: "Nous vous accueillons au Domaine — prenez le temps d'arriver et de découvrir les lieux.",
      place: "Domaine de l'Établière",
      icon: "users",
    },
    {
      time: "17h00",
      title: "Vin d'Honneur",
      desc: "Trinquez avec nous près de la piscine.",
      place: "Domaine de l'Établière",
      icon: "wine",
    },
    {
      time: "19h30",
      title: "Dîner",
      desc: "Un repas raffiné vous sera servi à l'Orangerie.",
      place: "Domaine de l'Établière",
      icon: "utensils",
    },
    {
      time: "22h30",
      title: "Soirée Dansante",
      desc: "Nous ouvrons le bal — et nous espérons vous voir nombreux sur la piste.",
      place: "Domaine de l'Établière",
      icon: "music",
    },
    {
      time: "11h30",
      title: "Brunch du Lendemain",
      desc: "Dimanche 16 mai, prolongeons la fête autour d'un brunch convivial.",
      place: "Domaine de l'Établière",
      icon: "coffee",
    },
  ],
  images: {
    hero: "https://images.unsplash.com/photo-1604017011826-d3b4c23f8914?auto=format&fit=crop&w=1400&q=80",
    chateau:
      "https://images.unsplash.com/photo-1588571088301-67a44e3d7ab7?auto=format&fit=crop&w=1200&q=80",
    parc: "https://images.unsplash.com/photo-1698933485983-8ec889b747b8?auto=format&fit=crop&w=1200&q=80",
    table:
      "https://images.unsplash.com/photo-1768777270907-235286662f98?auto=format&fit=crop&w=900&q=80",
  },
};

export const MENU_OPTIONS = [
  { value: "classique", label: "Menu Classique" },
  { value: "vegetarien", label: "Végétarien / Végétalien" },
  { value: "halal", label: "Menu Halal" },
  { value: "sans-porc", label: "Sans Porc" },
];

export const RESTRICTION_OPTIONS = [
  { value: "aucune", label: "Pas de restriction particulière" },
  { value: "vegetarien", label: "Végétarien / Végétalien / Végan" },
  { value: "halal", label: "Menu Halal" },
  { value: "sans-porc", label: "Sans Porc" },
  { value: "femme-enceinte", label: "Femme enceinte" },
  { value: "allergies", label: "Allergies spécifiques" },
];
